
export default (state = {}, action) => {
  switch (action.type) {
    case 'CATEGORY_FETCH_SUCCESS':
      return {
        category: action.payload,
        error: false

      }
    case 'CATEGORY_FETCH_FAILURE':
      return {
        category: [],
        error: true
      }
    default:
      return state
  }
}